import { ProgramItemTypeEnumType } from '../../types/services/magnolia/enums/ProgramItemTypeEnum';
import { actionCreators as profileAC } from '../profile/profile.actionCreators';
import {
	REQUEST_ADD_PERSISTENT_FILTER,
	REQUEST_REMOVE_PERSISTENT_FILTER,
	REQUEST_SELECTED_ITEM,
	REQUEST_SELECTED_ITEM_FAILURE,
	REQUEST_SELECTED_ITEM_SUCCESS,
	REQUEST_SET_DAY_REF,
	REQUEST_SET_OVERLAY_REF,
	REQUEST_SET_PERSISTENT_FILTER,
	REQUEST_SET_PROGRAM_ITEM_REF,
	REQUEST_UNSET_ALL_FILTERS,
	REQUEST_UNSET_CURRENT_OVERLAY_REF,
	REQUEST_UNSET_DAY_REF,
	REQUEST_UNSET_OVERLAY_REF,
	REQUEST_UNSET_PERSISTENT_FILTER,
	REQUEST_UNSET_PROGRAM_ITEM_REF,
} from './transientPoolState.actionTypes';

export const actionCreators = {
	doAddPersistentFilter: (filterId: string, filterFactoryKey: string) => ({
		type: REQUEST_ADD_PERSISTENT_FILTER,
		filterId,
		filterFactoryKey,
	}),
	doRemovePersistentFilter: (filterId: string, filterFactoryKey: string) => ({
		type: REQUEST_REMOVE_PERSISTENT_FILTER,
		filterId,
		filterFactoryKey,
	}),
	doSetPersistentFilter: (filterId: string, filterFactoryKey: string) => ({
		type: REQUEST_SET_PERSISTENT_FILTER,
		filterId,
		filterFactoryKey,
	}),
	doUnsetPersistentFilter: (filterId: string) => ({
		type: REQUEST_UNSET_PERSISTENT_FILTER,
		filterId,
	}),
	doUnsetAllFilters: () => ({
		type: REQUEST_UNSET_ALL_FILTERS,
	}),
	doSetProgramItemRef: (programItemRef: string | number, programItemExternalRef?: string) => ({
		type: REQUEST_SET_PROGRAM_ITEM_REF,
		programItemExternalRef,
		programItemRef,
	}),
	doUnsetProgramItemRef: (programItemRef: string) => ({
		type: REQUEST_UNSET_PROGRAM_ITEM_REF,
		programItemRef,
	}),
	doSetOverlayRef: (overlayRef: string) => ({
		type: REQUEST_SET_OVERLAY_REF,
		overlayRef,
	}),
	doUnsetOverlayRef: (overlayRef: string) => ({
		type: REQUEST_UNSET_OVERLAY_REF,
		overlayRef,
	}),
	doUnsetCurrentOverlayRef: () => ({
		type: REQUEST_UNSET_CURRENT_OVERLAY_REF,
	}),
	doLoadSelectedItem: (id: string, contentType: string) => ({
		type: REQUEST_SELECTED_ITEM,
		id,
		contentType,
	}),
	doLoadSelectedItemSuccess: (content: { contentType: ProgramItemTypeEnumType }, id: string) => ({
		type: REQUEST_SELECTED_ITEM_SUCCESS,
		content,
		id,
	}),
	doLoadSelectedItemFailure: (error: Error) => ({
		type: REQUEST_SELECTED_ITEM_FAILURE,
		error,
	}),
	doSetDayRef: (day: number) => ({
		type: REQUEST_SET_DAY_REF,
		day,
	}),
	doUnsetDayRef: () => ({
		type: REQUEST_UNSET_DAY_REF,
	}),
};

export type TransientPoolsActionType =
	| ReturnType<typeof actionCreators.doUnsetAllFilters>
	| ReturnType<typeof actionCreators.doAddPersistentFilter>
	| ReturnType<typeof actionCreators.doRemovePersistentFilter>
	| ReturnType<typeof actionCreators.doSetPersistentFilter>
	| ReturnType<typeof actionCreators.doUnsetPersistentFilter>
	| ReturnType<typeof actionCreators.doSetProgramItemRef>
	| ReturnType<typeof actionCreators.doUnsetProgramItemRef>
	| ReturnType<typeof actionCreators.doSetOverlayRef>
	| ReturnType<typeof actionCreators.doUnsetOverlayRef>
	| ReturnType<typeof actionCreators.doUnsetCurrentOverlayRef>
	| ReturnType<typeof actionCreators.doLoadSelectedItem>
	| ReturnType<typeof actionCreators.doLoadSelectedItemSuccess>
	| ReturnType<typeof actionCreators.doLoadSelectedItemFailure>
	| ReturnType<typeof actionCreators.doSetDayRef>
	| ReturnType<typeof actionCreators.doUnsetDayRef>;

export type SideEffectsActionTypes =
	| ReturnType<typeof profileAC.doLoadUserDataSuccess>
	| ReturnType<typeof profileAC.doSaveDietaryHabitsSuccess>
	| ReturnType<typeof actionCreators.doUnsetDayRef>;
